import React from "react";
import { TFunction } from "i18next";
import classnames from "classnames";

type Props = {
    selectedRows: FidelityRow[];
    oneShop: boolean;
    isFidelityArchived: boolean;
    dataArchive: string[];
    onClick: () => void;
    t: TFunction;
};

export default function BulkArchiveMenuItem({
    selectedRows,
    oneShop,
    isFidelityArchived,
    dataArchive,
    onClick,
    t,
}: Props) {
    const isDisabled =
        selectedRows.length === 0 ||
        (isFidelityArchived &&
            oneShop &&
            selectedRows.some((element: FidelityRow) =>
                dataArchive.includes(element.Id)
            )) ||
        (selectedRows.length > 0 &&
            selectedRows[0][t("State")] === true &&
            oneShop);

    const className = classnames("dropdown-item pl-1 pointer__clz", {
        "not-allowed-icon__clz": isDisabled,
    });

    return (
        <div
            data-testid="fidelity-franchise-bulk-archive-toggle"
            style={{ cursor: "pointer" }}
            className={className}
            onClick={onClick}
        >
            <span className="ml-2 cmn_btn_FRarchived cmn_btn_FRunarchive">
                {isFidelityArchived ? t("unarchive") : t("archive")}
            </span>
        </div>
    );
}
